// images
const img1 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9468bf33e1f9810aed_Group%201%20(4).png' ; // Reward your team
const img2 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67fe4885c39a459a65f74e7b_refer%20and%20earn%20(1).png'; // Refer a friend
const img3 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9468bf33e1f9810afd_Group%203.png'; // Team Performance
const img4 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9468bf33e1f9810add_Frame%202%20(1).png'; // NPS/CSAT
const img5 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9468bf33e1f9810b3d_Frame%201%20(2).png'; // Customize mobile review
const img6 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9468bf33e1f9810b0d_Frame%203.png'; // AI Surveys
const img7 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9468bf33e1f9810b2d_Frame%205%20(1).png'; // Coupons
const img8 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9468bf33e1f9810b1d_Frame%201618869448%20(1).png'; // Campaigns
const img9 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9c09fe41e66574086e_3_2%20screen%20mockup%20(3).png'; // Instant Insights
import FeatureSection from '../components/FeatureSection';


const sections = [
  {
    title: "Reward your team for generating more reviews",
    description:
      "Motivate your team to proactively seek customer reviews by launching a well-structured incentive program. Boost participation by recognizing and rewarding top performers, fostering engagement and strengthening your brand’s reputation.",
    image: img1,
    reverse: true,
  },
  {
    title: "Refer a Friend — Everyone Wins!",
    description:
      "Spread the word. Earn rewards. Help your friends discover great service.",
    image: img2,
  },
  {
    title: "Team Performance",
    description:
      "Use leaderboards to drive engagement by tapping into the power of friendly competition, motivating customers to leave more reviews and increase overall participation.",
    image: img3,
    reverse: true,
  },
  {
    title: "Motivate your team to enhance Net Promoter Scores (NPS) and Customer Satisfaction (CSAT)",
    description:
      "Inspire your team with targeted incentives to boost Net Promoter Scores (NPS) and Customer Satisfaction (CSAT), fostering outstanding customer experiences.",
    image: img4,
  },
  {
    title: "Personalize Your Mobile Review Page",
    description:
      "Customize your mobile review page to improve user experience and increase engagement. Adjust the layout and content to highlight essential insights in a more impactful way.",
    image: img5,
    reverse: true,

  },
  {
    title: "AI Generated Surveys",
    description:
      "You can create AI-generated surveys to streamline data collection and gain valuable insights for your business.",
    image: img6,
  },
  {
    title: "Coupons",
    description:
      "You can create exclusive coupons for your customers to encourage repeat business and enhance customer loyalty.",
    image: img7,
    reverse: true,

  },
  {
    title: "Campaigns",
    description:
      "You can create exclusive coupons for your customers to encourage repeat business and enhance customer loyalty.",
    image: img8,
  },
  {
    title: "Instant Data Insights",
    description:
      "Gain real-time insights through Zola’s intuitive analytics dashboard. Track customer sentiment, spot trends, and understand what drives satisfaction.",
    image: img9,
    eyebrow: "Features",
    showEyebrow: true,
    reverse: true,
  },
];

function AllFeatures() {
  return (
    <>
      {sections.map((section, index) => (
        <FeatureSection key={index} {...section} />
      ))}
    </>
  );
}

export default AllFeatures;
